<template>
    <div>
        <div class="snippet event-domain-snippet">

            <div class="form-group row">
            <div class="col-lg-12">
                <DropFiles :file="validate_file(item.background_picture)" 
                            :module_id="item._id?item._id:this.moduleId" 
                            dimmention="2725X519"
                            @onUploaded="updateBackgroundPicture" 
                            @onRemoved="removeBackgroundPicture"
                            :accept="'image/jpeg'"
                            module_type="events" 
                            asset_type="exhibition_hall_background_image"  
                            @onError="errCb">

                <template #header>
                    <label>Background Picture (Size should be 2725x519 pixel and format JPG.) </label>
                </template>
                <template #tooltip>
                    <VTooltip style="display:inline-block">
                    <i class="fa fa-info-circle" style="font-size:16px"></i>
                    <template #popper>
                        <img src="/admin_assets/img/event_garden_smallbanner_5.png"/>
                    </template>
                    </VTooltip>
                </template>
                </DropFiles>
            </div>
            
            </div>
            <!--
            <div class="form-group row">
            <div class="col-lg-12">
                <DropFiles :file="validate_file(item.exhibition_area)" 
                            :module_id="item._id" 
                            dimmention="2725X519"
                            @onUploaded="updateExhibitionArea" 
                            @onRemoved="removeExhibitionArea"
                            :accept="'image/jpeg'"
                            module_type="events" 
                            asset_type="exhibition_hall_background_image"  
                            @onError="errCb">

                <template #header>
                    <label>Exhibition  Area  Picture (Size should be 2725x519 pixel and format JPG.)</label>
                </template>
                <template #tooltip>
                    <VTooltip style="display:inline-block">
                    <i class="fa fa-info-circle" style="font-size:16px"></i>
                    <template #popper>
                        <img src="/admin_assets/img/event_garden_smallbanner_5.png"/>
                    </template>
                    </VTooltip>
                </template>
                </DropFiles>
            </div>
            
        </div>
            -->
            <div class="form-group row">
            <div class="col-lg-6">
                <label>Exhibition Area Name *</label>
                <div class="kt-input-icon">
                    <input
                      type="text"
                      class="form-control"
                      name="scrolling Text"
                      placeholder="Enter Exhibition Area Name"
                      :value="item.name"
                      @input="updateName"
                    />
                </div>
            </div>
        </div>

        <div class="form-group row">
            <div class="form-group col-lg-4" >
                <label class>Exhibtion Area Type: *</label>
                <div>
                <select class="form-control" @change="updateType">
                  <option value="" selected>Select</option>
                  <option v-for="option in exhibtion_area_type" :value="option.id" :key="option.id"
                    :selected="(item.type == option.id)">
                    {{ option.title }}
                  </option>
                </select>

                   
                </div>
            </div>
        </div>
         



            <div class="form-group row">
            <div class="col-lg-6">
                <label>Scrolling Text *</label>
                <div class="kt-input-icon">
                    <input
                      type="text"
                      class="form-control"
                      name="scrolling Text"
                      placeholder="Enter Scrolling Text"
                      :value="item.scrolling_text"
                      @input="updateScrollingText"
                    />
                </div>
            </div>
        </div>
        <div class="form-group row" >
            <div class="col-lg-6">
                <label>Scrolling Text Background</label>
                <VPopper  arrow hover style="display:inline-block" class="dark">
                    <i class="fa fa-info-circle" style="font-size:16px"></i>
                    <template #content>
                    Enter hexa color code e.g #abc234
                    </template>
                </VPopper>
                <div class="input-group color" data-plugin-colorpicker>
                <input
                    type="color"
                    class="form-control"
                    name="theme_booth_box_color"
                    placeholder="Enter color code"
                    :value="item.scrolling_text_background_color"
                    @input="updateScrollingTextBackgroundColor" />
                </div>
                
                
            </div>
        </div>


        <div class="form-group row">
            <div class="col-lg-2">
            <label>Skybox</label>
            <br />
            <div class="custom-control custom-switch">
            <input-switch name="skybox_is_custom" :value="item.skybox_is_custom" id="customSwitchesEx" class="custom-control-input" @change="updateSkybox_is_custom" />
                <label
                class="custom-control-label"
                for="customEF"
                >{{item.skybox_is_custom ? 'Custom' : 'Pre Defined'}}</label>
            </div>
        </div>



            <div class="col-lg-4" v-show="item.skybox_is_custom" >

                <DropFiles :file="validate_file(item.skybox_picture)" 
                            :module_id="item._id?item._id:this.moduleId" 
                            dimmention="4096X4096"
                            @onUploaded="updateSkyboxPicture" 
                            @onRemoved="removeSkyboxPicture"
                            :accept="'image/jpeg'"
                            module_type="events" 
                            asset_type="skybox_picture"  
                            @onError="errCb">

                <template #header>
                    <label>Sky box Picture (Size should be 4096x4096 pixel and format JPG.)</label>
                </template>
                <template #tooltip>
                    <VTooltip style="display:inline-block">
                    <i class="fa fa-info-circle" style="font-size:16px"></i>
                    <template #popper>
                        <img src="/admin_assets/img/event_garden_smallbanner_5.png"/>
                    </template>
                    </VTooltip>
                </template>
                </DropFiles>
                
            </div>
            <div class="form-group col-lg-4" v-show="!item.skybox_is_custom">
                <label class>Sky Box:</label>
                <div>
                <select class="form-control" @change="updateSkybox">
                  <option value="" selected>Select</option>
                  <option v-for="option in skyboxes" :value="option.id" :key="option.id"
                    :selected="(item.skybox == option.id)">
                    {{ option.title }}
                  </option>
                </select>

                   
                </div>
            </div>
        </div>

        
  
        <div class="form-group row" >
            <div class="col-lg-2">
                <label>Environment</label>
                <br />

                <input-switch name="environment_is_custom" :value="item.environment_is_custom" id="customSwitchesEx" class="custom-control-input" @change="updateEnvironment_is_custom" />
                  
                   
                    <label
                      class="custom-control-label"
                      for="customEG"
                    >{{item.environment_is_custom ? 'Custom' : 'Pre Defined'}}</label>
                
            </div>



            <div class="col-lg-4" v-show="item.environment_is_custom">

                <DropFiles :file="validate_file(item.environment_picture)" 
                             :module_id="item._id?item._id:this.moduleId"
                            dimmention="6000X1113"
                            @onUploaded="updateEnvironmentPicture" 
                            @onRemoved="removeEnvironmentPicture"
                            :accept="'image/png'"
                            module_type="events" 
                            asset_type="environment_picture"  
                            @onError="errCb">

                <template #header>
                    <label>Environment Picture (Size should be 6000x1113 pixel and format PNG.)</label>
                </template>
                <template #tooltip>
                    <VTooltip style="display:inline-block">
                    <i class="fa fa-info-circle" style="font-size:16px"></i>
                    <template #popper>
                        <img src="/admin_assets/img/event_garden_smallbanner_5.png"/>
                    </template>
                    </VTooltip>
                </template>
                </DropFiles>
              
            </div>

            <div class="form-group col-lg-4" v-show="!item.environment_is_custom">
                <label class>Environment:</label>
                <div>

                    <select class="form-control" @change="updateEnvironment">
                  <option value="" selected>Select</option>
                  <option v-for="option in environments" :value="option.id" :key="option.id"
                    :selected="(item.environment == option.id)">
                    {{ option.title }}
                  </option>
                </select>

                   
                </div>
            </div>
        </div>
        <div class="form-group row">
            <div class="col-lg-2">
                <label for="max_count_booth">Count Booth (1 - 100)</label>
            </div>
            <div class="col-lg-4">
                <label for="max_count_booth">How many booths do you want to see per hall?</label>
                <input
                    disabled="disabled"
                    id="max_count_booth"
                    class="form-control"
                    type="number"
                    min="1"
                    :max="item.type === 'small' ? 5 : item.type === 'medium' ? 10 : item.type === 'large' ? 15 : 0"
                    :value="item.type === 'small' ? 5 : item.type === 'medium' ? 10 : item.type === 'large' ? 15 : 0"
                    @input="updateMaxCountBooth"
                />
            </div>
        </div>
    </div>
</div>
<FlashMessage group="exhibition_area_theme" />
 
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import _, { update } from 'lodash';
import InputSwitch from "@/components/Commons/InputSwitch";
import ObjectID from 'bson-objectid';
import $ from 'jquery';

export default {
    name: "ThemeContentsTab",
    components: {
      InputSwitch
    },
    data() {
        return {
            moduleId: ObjectID(),
        }
    },
    created() {
        console.log("item===> theme content tabs", this.item);
        const switchers = document.querySelectorAll('.general-event-config-snippet input[data-plugin-ios-switch]')
        switchers.forEach(item => {
            const elem = new window.theme.PluginIOS7Switch($(item))
        })
        
    },
    beforeUnmount() {
      this.resetState();
      delete this.$flashMessage.groups.exhibition_area_theme;
    },
    computed: {
        ...mapGetters("ExhibitionAreasSingle", [
            "item",
            "event_type",
            "skyboxes",
            "environments",
            "exhibtion_area_type"
        ])
    },
    watch: {
       
    },
    methods: {
        ...mapActions("ExhibitionAreasSingle", [
            "setEvent",
            "setSkybox",
            "setEnvironment",
            "setScrollingText",
            "setSkybox",
            "setEnvironmentPicture",
            "setSkyboxPicture",
            "skybox_is_custom",
            "setSkybox_is_custom",
            "setEnvironment_is_custom",
            "setExhibitionPicture",
            "setScreenDesc1",
            "setScreenDesc2",
            "setMaxCountBooth",
            "setExhibition_area",
            "setBackgroundPicture",
            "setName",
            "setType",
            "resetState",
            "setScrollingTextBackground"
        ]),

        validate_file(fileInfo) {
            if (_.has(fileInfo, 'key'))
                return fileInfo;
        return null;
        },

        updateSkybox_is_custom(e) {
            this.setSkybox_is_custom(e.target.checked);
        },
        updateEnvironment_is_custom(e) {
            this.setEnvironment_is_custom(e.target.checked);
        },
        updateScreenDesc1(e) {
            this.setScreenDesc1(e.target.value);
        },
        updateScreenDesc2(e) {
            this.setScreenDesc2(e.target.value);
        },
        updateBackgroundPicture(info, data) {
            if (!_.has(data, 'data.key')) {
                return;
            }
            const extension = data.data.key.split('.').pop();
            const key = _.get(this.item.background_picture, 'key', null);
            const size = _.get(info, 'file.size', 0);
            this.setBackgroundPicture({
                old_key: key,
                key: data.data.key,
                temp_key: info.id,
                size: size.toString(),
                extension: extension,
                uploadedBy:  info.user.first_name + ' ' + info.user.last_name,
                uploadedAt: '2023.01.01',
            });
        },
        removeBackgroundPicture(e) {
            this.setBackgroundPicture(null);
        },

        updateExhibitionArea(info, data) {
            if (!_.has(data, 'data.key')) {
                return;
            }
            const extension = data.data.key.split('.').pop();
            const key = _.get(this.item.exhibition_area, 'key', null);
            const size = _.get(info, 'file.size', 0);
            this.setExhibition_area({
                old_key: key,
                key: data.data.key,
                temp_key: info.id,
                size: size.toString(),
                extension: extension,
                uploadedBy:  info.user.first_name + ' ' + info.user.last_name,
                uploadedAt: '2023.01.01',
            });
        },
        removeExhibitionArea(e) {
            this.setExhibition_area(null);
        },
        errCb(e){
            console.log(e)
            this.$flashMessage.show({
                group : 'exhibition_area_theme',
                type  : 'error',
                title : 'Failed',
                html  : "<ul><li>Invalid File/Doc format.Please use described valid format</li></ul>"

            })
        },
        removeSkyboxPicture(e) {
            this.setSkyboxPicture(null);
        },
        removeEnvironmentPicture(e) {
            this.setEnvironmentPicture(null);
        },
        updateEvent(value) {
            this.setEvent(value);
        },
        updateSkyboxPicture(info,data) {
            if (!_.has(data, 'data.key')) {
                return;
            }
            const extension = data.data.key.split('.').pop();
            const key = _.get(this.item.skybox_picture, 'key', null);
            const size = _.get(info, 'file.size', 0);
            this.setSkyboxPicture({
                old_key: key,
                key: data.data.key,
                temp_key: info.id,
                size: size.toString(),
                extension: extension,
                uploadedBy:  info.user.first_name + ' ' + info.user.last_name,
                uploadedAt: '2023.01.01',
            });
        },
        updateEnvironmentPicture(info, data) {
           if (!_.has(data, 'data.key')) {
                return;
            }
            const extension = data.data.key.split('.').pop();
            const key = _.get(this.item.environment_picture, 'key', null);
            const size = _.get(info, 'file.size', 0);
            this.setEnvironmentPicture({
                old_key     : key,
                key         : data.data.key,
                temp_key    : info.id,
                size        : size.toString(),
                extension   : extension,
                uploadedBy  :  info.user.first_name + ' ' + info.user.last_name,
                uploadedAt  : '2023.01.01',
            });
        },
        updateSkybox(e) {
            this.setSkybox(e.target.value);
        },
        updateEnvironment(e) {
            this.setEnvironment(e.target.value);
        },
        updateScrollingText(e) {
            this.setScrollingText(e.target.value);
        },
        updateMaxCountBooth(e) {
            this.setMaxCountBooth(e.target.value);
        },
        updateName(e) {
            this.setName(e.target.value);
        },
        updateType(e) {
            this.setType(e.target.value);
            let count = this.item.type === 'small' ? 5 : this.item.type === 'medium' ? 10 : this.item.type === 'large' ? 15 : 0;
            this.setMaxCountBooth(count);
      
        },
        updateScrollingTextBackgroundColor(e) {
            this.setScrollingTextBackground(e.target.value);
        },
    }
}
</script>

<style scoped>

</style>